import { Navigate, useLoaderData, useRevalidator } from "react-router-dom"
import { PlanBillingScreen } from "@/components/screens/PlanBillingScreen"
import { useSession } from "@/lib/session-context"

export function BillingHydrateFallback() {
  return null
}

export function BillingRoute() {
  const { currentUser } = useSession()
  const { plans, trial, plansLoadFailed } = useLoaderData()
  const revalidator = useRevalidator()

  if (!currentUser) return <Navigate to="/sign-in" replace />

  return (
    <PlanBillingScreen
      plans={plans}
      trial={trial}
      plansLoadFailed={plansLoadFailed}
      plansLoading={revalidator.state !== "idle"}
      onRetryPlans={() => revalidator.revalidate()}
    />
  )
}
